import { auth } from '@/api/openapi/middleware';
import { paths } from '@/api/openapi/schema';
import createClient from 'openapi-fetch';

export const evaluate = async (answer: string, refText: string, token: string) => {
    if (!answer || !refText || !token) {
        return null;
    }

    // Create the API client and send the assessment request
    const client = createClient<paths>({ baseUrl: `${import.meta.env.VITE_API_SERVICE_URL}/v1` });
    client.use(auth(token));
    const { data } = await client.POST('/assessments/audios/evaluations', {
        body: {
            data: answer,
            refText: refText,
        },
    });
    return data;
};
